module.exports = __webpack_public_path__ + "static/img/frozen-phase-3.8375def.png";